import { Select } from "antd";
import React from "react";
import {
  DEFAULT_UNITS,
  ENERGY_UNITS,
  LENGTH_UNITS,
  SPEED_UNITS,
} from "../../utils/constants";

const UnitsConfiguration = ({ units, handleUnitConfigChange }) => {
  // Map UI field names to API field names
  const fieldMapping = {
    "Arc Current": "current",
    "Arc Volts": "volts",
    Frequency: "frequency",
    Target: "target",
    "Horizontal Bias": "horizontal_bias",
    "Arc Impedance": "arc_impedance",
    "Travel Speed": "travel_speed",
    "Wire Speed": "wire_speed",
    Heat: "heat",
    "True Energy": "true_energy",
    "Oscillation Width": "oscillation_width",
    "Total Wire Consumed": "total_wire_consumed",
    "Wall Thickness": "wall_thickness",
    "Pipe Diameter": "pipe_diameter",
    "Band Diameter": "band_diameter",
    "Wire Diameter": "wire_diameter",
    "Logging Distance": "logging_distance",
  };

  const handleUnitChange = (uiField, unit) => {
    const apiField = fieldMapping[uiField];
    handleUnitConfigChange(apiField, unit);
  };

  // Units configuration fields in display order
  const unitsFields = [
    "Travel Speed",
    "Wire Speed",
    "Heat",
    "True Energy",
    "Oscillation Width",
    "Total Wire Consumed",
    "Wall Thickness",
    "Pipe Diameter",
    "Band Diameter",
    "Wire Diameter",
    "Logging Distance",
  ];

  const renderUnitSelector = (uiField) => {
    const apiField = fieldMapping[uiField];

    if (uiField.includes("Speed")) {
      return (
        <Select
          defaultValue={DEFAULT_UNITS[apiField]}
          value={units[apiField]}
          style={{ width: "100%" }}
          onChange={(unit) => handleUnitChange(uiField, unit)}
          className="unit-select"
        >
          {SPEED_UNITS.map((unit) => (
            <Select.Option key={unit.value} value={unit.value}>
              {unit.label}
            </Select.Option>
          ))}
        </Select>
      );
    }

    if (uiField.includes("Heat") || uiField.includes("Energy")) {
      return (
        <Select
          defaultValue={DEFAULT_UNITS[apiField]}
          value={units[apiField]}
          style={{ width: "100%" }}
          onChange={(unit) => handleUnitChange(uiField, unit)}
          className="unit-select-capitalize"
        >
          {ENERGY_UNITS.map((unit) => (
            <Select.Option key={unit.value} value={unit.value}>
              {unit.label}
            </Select.Option>
          ))}
        </Select>
      );
    }

    // Length units for width, thickness, diameter, etc.
    if (
      uiField.includes("Width") ||
      uiField.includes("Wire") ||
      uiField === "Wall Thickness" ||
      uiField === "Pipe Diameter" ||
      uiField === "Band Diameter" ||
      uiField === "Wire Diameter" ||
      uiField === "Logging Distance"
    ) {
      return (
        <Select
          defaultValue={DEFAULT_UNITS[apiField]}
          value={units[apiField]}
          style={{ width: "100%" }}
          className="unit-select"
          onChange={(unit) => handleUnitChange(uiField, unit)}
        >
          {LENGTH_UNITS.map((unit) => (
            <Select.Option key={unit.value} value={unit.value}>
              {unit.label}
            </Select.Option>
          ))}
        </Select>
      );
    }

    return null;
  };

  return (
    <div className="report-config-content">
      <div className="report-params-table">
        <div className="report-table-body">
          <p className="units-selection-header">Unit Selection</p>

          {unitsFields.map((uiField) => {
            const apiField = fieldMapping[uiField];
            return (
              <div key={apiField} className="report-table-row">
                <div className="param-col">{uiField}</div>
                <div className="unit-col">{renderUnitSelector(uiField)}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default UnitsConfiguration;
